// extracted by mini-css-extract-plugin
export default {"container":"securityupdate_container__qwRrI","text":"securityupdate_text__buXPy"};